import { SkladOV } from './skladOV';

export const menu = {
	name: 'CiselnikOjeteVozy',
	list: [
		{ name: 'Skladov', route: SkladOV.name },
	],
};
